import { client } from "../client";
import { User } from "../types/user.types";

export const updateUser = async (props: Partial<User> & { centerId?: number | string | null }) => {
  if (!props.id) {
    return null;
  }
  const response = await client.patch<User>(`/users/${props.id}`, props);
  return response.data;
};

export const createUser = async ({ user, centerId, invitation = false }: { user: Partial<User>, centerId?: number, invitation?: boolean }) => {
  const response = await client.post<User>(`/users/`, {
    ...user,
    invitation,
    centerId,
  });
  return response.data;
};

export const deleteUser = async ({ id }: { id: number | undefined }) => {
  if (id === undefined) {
    return null;
  }
  const response = await client.delete<User>(`/users/${id}`);
  return response.data;
}

export const unlinkUser = async ({ id, userId }: { id?: number | string | null, userId?: number | string | null}) => {
  if (userId == undefined || id == undefined) {
    return null;
  }
  const response = await client.post(`/centers/${id}/unlink`, {
    user_id: userId
  });
  return response.data;
}